import type { LoginCredentials, LoginResponse, LoginSuccessResponse, OtpVerifyCredentials } from "../types/auth.type"

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.yourdomain.gov.mm/v1'

// Primary login function
export async function loginUser(credentials: LoginCredentials): Promise<LoginResponse> {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(credentials),
  })

  const data = await response.json()

  if (!response.ok) {
    throw new Error(data.message || 'အီးမေးလ် သို့မဟုတ် လျှို့ဝှက်နံပါတ် မှားယွင်းနေပါသည်။')
  }

  return data as LoginResponse
}

// 2FA / OTP Verification function
export async function verifyOtp(credentials: OtpVerifyCredentials): Promise<LoginSuccessResponse> {
  const response = await fetch(`${API_BASE_URL}/auth/2fa/authenticate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      userId: credentials.userId,
      code: credentials.code, // 👈 Backend မျှော်လင့်ထားသည့် 'code' key Name
    }),
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || 'Invalid OTP Code')
  }

  return response.json()
}


export async function verifySession(): Promise<boolean> {
  const token = localStorage.getItem('access_token')
  if (!token) return false

  const response = await fetch(`${API_BASE_URL}/auth/me`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json',
    },
  })

  return response.ok // Returns true if 200 OK, false if 401 Unauthorized
}

export async function requestPasswordReset(email: string): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || 'အီးမေးလ် ပို့ဆောင်၍ မရပါ')
  }
}

export async function resetPassword(payload: {
  userId: string
  token: string
  password: string
}): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    throw new Error(data.message || 'လျှို့ဝှက်နံပါတ် ပြန်လည်သတ်မှတ်၍ မရပါ။')
  }
}